var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('AppContainer',[_c('Header',{attrs:{"environmentName":_vm.envName,"organisationName":_vm.orgName,"userName":_vm.userName,"isAuthed":_vm.isAuthed},on:{"logout":_vm.logout}}),_c('router-view'),_c('Loader'),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }